import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../Footer'
import axios from 'axios'
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BtnLoader } from '../components/PageLoader';


const Register = () => {
  const optionToast = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [userOTP, setUserOtp] = useState('')
  const [errors, setErrors] = useState({});
  const [processing, setProcessing] = useState(false);
  const navigator = useNavigate();
  const togglePasswordVisibility = () => {

    setShowPassword(!showPassword);
  };
  const togglePasswordVisibilityConfirm = () => {

    setShowPasswordConfirm(!showPasswordConfirm);
  };

  const validate = () => {
    const newErrors = {};

    if (!firstName.match(/^[A-Za-z]+$/)) {
      newErrors.firstName = "First name must contain only letters";
    }

    if (!email.match(/^\S+@\S+\.\S+$/)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!password) {
      newErrors.password = "Password is required";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (!phone.match(/^\+?\d{10,15}$/)) {
      newErrors.phone = "Enter a valid phone number (10-15 digits, optional '+').";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSignUp = () => {
    // Validate all fields
    setProcessing(true);
    var isValidate = validate();
    if (!isValidate) {
      // If any field is empty, show an error
      toast.error("All fields are required", optionToast);
      setProcessing(false);
      return;
    }

    // Check if the password and confirmPassword match
    if (password !== confirmPassword) {
      toast.error("Password does not match the confirmation password", optionToast);
      setProcessing(false);
      return;
    }


    // You can perform additional actions like sending data to a server, validation, etc.
    if (!showOtpInput) {
      sendOtpData()
    } else {
      // console.log(userOTP, otp)
      if (userOTP === parseInt(otp)) {

        saveData();
      }
      else {
        toast.error('Invalid otp', optionToast)
        setProcessing(false);
      }
    }
  };
  const sendOtpData = async () => {
    setProcessing(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/user/email/verify",
        {
          email: email,
        }
      );

      // console.log(response?.data?.otp);
      if (response?.data?.status) {
        setUserOtp(response?.data?.otp)
        toast.success(response?.data?.message, optionToast)

        setShowOtpInput(true)

      } else {
        toast.error(response?.data?.message, optionToast)

      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
    setProcessing(false);
  };
  const saveDataTolocalStorage = (key, data) => {
    try {
      const serializedData = JSON.stringify(data);
      localStorage.setItem(key, serializedData);
    } catch (error) {
      console.error("Error saving data to localStorage:", error);
    }
  };
  const saveData = async () => {
    setProcessing(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/register/user",
        {
          email: email,
          phone: phone,
          password: password,
          first_name: firstName,
          last_name: lastName,
        }
      );
      // console.log(firstName + " " + lastName);

      // console.log(response?.data);
      if (response?.data?.status) {
        toast.success(response?.data?.message, optionToast)
        const newUserData = { ...response?.data?.data };
        if (response?.data?.token) {
          newUserData.token = response?.data?.token;
        }
        saveDataTolocalStorage("userData", newUserData);
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setPassword('');
        setConfirmPassword('');
        setOtp('')
        setShowOtpInput(false)
        setTimeout(() => {
          navigator('/profilesetting');
        }, 1500);
      } else {

        toast.error(response?.data?.message, optionToast)
      }


    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
    setProcessing(false);
  };


  return (
    <>
      <Navbar />
      <div className="cl-auth-page" style={{ paddingTop: 78 }}>
        <div className="cl-auth-card" style={{ maxWidth: 500 }}>
          <div className="text-center mb-3">
            <img src="/img/logo.png" alt="Carloca" style={{ height: 44, marginBottom: 10 }} />
          </div>
          <h5 className="cl-auth-title">Create Your Account</h5>
          <p className="cl-auth-subtitle">Enter your details below to get started</p>

          <form method="post" className="w-100" onSubmit={(e) => { e.preventDefault(); handleSignUp(); }}>
            <div className="row">
              <div className="col-6 mb-3">
                <label className="cl-form-label">First Name*</label>
                <input type="text" placeholder="John"
                  className={`cl-form-control ${errors.firstName ? 'border-danger' : ''}`}
                  value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                {errors.firstName && <small className="text-danger">{errors.firstName}</small>}
              </div>
              <div className="col-6 mb-3">
                <label className="cl-form-label">Last Name*</label>
                <input type="text" placeholder="Doe" className="cl-form-control"
                  value={lastName} onChange={(e) => setLastName(e.target.value)} />
              </div>
            </div>
            <div className="mb-3">
              <label className="cl-form-label">Email*</label>
              <div className="position-relative">
                <input type="email" placeholder="you@email.com"
                  className={`cl-form-control ${errors.email ? 'border-danger' : ''}`}
                  style={{ paddingLeft: 38 }}
                  value={email} onChange={(e) => setEmail(e.target.value)} />
                <i className="fa-solid fa-envelope" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
              </div>
              {errors.email && <small className="text-danger">{errors.email}</small>}
            </div>
            <div className="mb-3">
              <label className="cl-form-label">Phone*</label>
              <div className="position-relative">
                <input type="tel" placeholder="+44 7700 900000"
                  className={`cl-form-control ${errors.phone ? 'border-danger' : ''}`}
                  style={{ paddingLeft: 38 }}
                  value={phone} onChange={(e) => setPhone(e.target.value)} />
                <i className="fa-solid fa-phone" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
              </div>
              {errors.phone && <small className="text-danger">{errors.phone}</small>}
            </div>
            <div className="mb-3">
              <label className="cl-form-label">Password*</label>
              <div className="position-relative">
                <input type={showPassword ? 'text' : 'password'} placeholder="***************"
                  className={`cl-form-control ${errors.password ? 'border-danger' : ''}`}
                  style={{ paddingLeft: 38, paddingRight: 40 }}
                  value={password} onChange={(e) => setPassword(e.target.value)} />
                <i className="fa-solid fa-lock" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
                <div style={{ position: 'absolute', top: '50%', right: 12, transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={togglePasswordVisibility}>
                  <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} style={{ color: '#b0bac5', fontSize: 14 }}></i>
                </div>
              </div>
              {errors.password && <small className="text-danger">{errors.password}</small>}
            </div>
            <div className="mb-3">
              <label className="cl-form-label">Confirm Password*</label>
              <div className="position-relative">
                <input type={showPasswordConfirm ? 'text' : 'password'} placeholder="***************"
                  className={`cl-form-control ${errors.confirmPassword ? 'border-danger' : ''}`}
                  style={{ paddingLeft: 38, paddingRight: 40 }}
                  value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                <i className="fa-solid fa-lock" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
                <div style={{ position: 'absolute', top: '50%', right: 12, transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={togglePasswordVisibilityConfirm}>
                  <i className={`fa-solid ${showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'}`} style={{ color: '#b0bac5', fontSize: 14 }}></i>
                </div>
              </div>
              {errors.confirmPassword && <small className="text-danger">{errors.confirmPassword}</small>}
            </div>
            {showOtpInput && (
              <div className="mb-3">
                <label className="cl-form-label">OTP Code*</label>
                <div className="position-relative">
                  <input type="text" placeholder="Enter OTP" className="cl-form-control" style={{ paddingLeft: 38 }}
                    value={otp} onChange={(e) => setOtp(e.target.value)} />
                  <i className="fa-solid fa-key" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
                </div>
                <small className="text-muted d-block mt-1">Check your junk/spam folder if you don't see the email.</small>
              </div>
            )}
            <button type="submit" disabled={processing} className="cl-btn cl-btn-primary cl-btn-lg w-100">
              {processing ? <><BtnLoader />{!showOtpInput ? 'Signing up...' : 'Verifying...'}</> : (!showOtpInput ? 'Sign Up' : 'Verify OTP')}
            </button>
            <div className="cl-auth-divider mt-3">Already have an account?</div>
            <Link to="/login" className="cl-btn cl-btn-outline cl-btn-lg w-100">Sign In</Link>
          </form>
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  )
}

export default Register
